// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  display: flex;
  background-color: ghostwhite;
  max-height: 60px;
  justify-content: left;
  align-items: flex-start;
  padding: 10px;
}

.profile-button-icon {
  margin-top: 5px;
  margin-bottom: 5px;
}

.hamburger-menu-icon {
  display: flex;
  justify-content: flex-start;
  background-color: rgba(136, 137, 148, 0.055);
  border-radius: 5px;
  border: 1px;
  border-color: rgba(169, 169, 169, 0.466);
  border-style: solid;
  margin-bottom: 4px;
  margin-top: 10px;
}

.header-newsie-title {
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 2px;
  margin: auto;
  font-size: 1.3em;
  margin-left: 10px;
}

.newsie-menu-icon-container {
  display: flex;
  flex: 1 1;
  height: 100%;
  align-items: flex-start;
}

.newsie-header-middle {
  flex: 2.3 1;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 80%;
  margin-left: 10%;
}

.instructions-question-icon-layout {
  max-height: 90%;
  display: flex;
  flex: 1 1;
  justify-content: center;
  margin-top: 1%;
  padding: 10px;
}

.instructions-question-icon {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.instructions-clue-icon {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.newsie-header-clue-button-container {
  width: 50%;
}

.newsie-header-clue-button-container.no-clue {
  display: none;
}

.newsie-header-clue-button-container.strobe {
  background-color: rgba(42, 85, 165, 0.137);
  animation: flickerAnimation 2s infinite;
  border-radius: 10%;
}

.newsie-header-clue-button-layout {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.newsie-header-clue-button {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-right: 5%;
  font-size: 0.75em;
}

.newsie-header-clue-button-text {
  font-weight: 900;
  font-size: xx-small;
  margin: 3px;
}

.instructions-question-icon-container {
  border-style: solid;
  border-width: 0.5px;
  border-color: rgba(169, 169, 169, 0.705);
  padding: 1%;
  border-radius: 5px;
  box-shadow: 1px 1px 1px rgba(255, 0, 0, 0.096);
  min-width: 50px;
  background-color: rgba(136, 137, 148, 0.055);
  margin-bottom: 3px;
}

@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}

.client-user-menu-container {
  display: flex;
  align-items: center;
  flex: 1 1;
  background-color: rgba(255, 255, 255, 0.938);
  border: 1px;
  border-color: rgba(9, 35, 53, 0.411);
  border-style: solid;
  border-radius: 3px;
  padding-right: 8px;
  padding-left: 8px;
  justify-content: flex-start;
}

@media (max-width: 400px) {
  .client-portal-user-name-text {
    display: none;
  }
  .client-user-menu-container {
    background-color: transparent;
    border: none;
  }
  .profile-button-icon {
    padding: 10px;
    border-radius: 10px;
    background-color: rgb(143, 168, 188);
  }
}

.unauthed-header-title-text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: x-large;
  margin-left: 10px;
  font-weight: bold;
}

.header-menu-buttons-container {
  /* flex: 1; */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Authenticated/HeaderMenu/HeaderMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,4CAA4C;EAC5C,kBAAkB;EAClB,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAS;EACT,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAO;EACP,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAI1C,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAmCA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,4CAA4C;EAC5C,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,6BAA6B;IAC7B,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,oCAAoC;EACtC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".header-container {\n  display: flex;\n  background-color: ghostwhite;\n  max-height: 60px;\n  justify-content: left;\n  align-items: flex-start;\n  padding: 10px;\n}\n\n.profile-button-icon {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.hamburger-menu-icon {\n  display: flex;\n  justify-content: flex-start;\n  background-color: rgba(136, 137, 148, 0.055);\n  border-radius: 5px;\n  border: 1px;\n  border-color: rgba(169, 169, 169, 0.466);\n  border-style: solid;\n  margin-bottom: 4px;\n  margin-top: 10px;\n}\n\n.header-newsie-title {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  gap: 2px;\n  margin: auto;\n  font-size: 1.3em;\n  margin-left: 10px;\n}\n\n.newsie-menu-icon-container {\n  display: flex;\n  flex: 1;\n  height: 100%;\n  align-items: flex-start;\n}\n\n.newsie-header-middle {\n  flex: 2.3;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  height: 80%;\n  margin-left: 10%;\n}\n\n.instructions-question-icon-layout {\n  max-height: 90%;\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  margin-top: 1%;\n  padding: 10px;\n}\n\n.instructions-question-icon {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.instructions-clue-icon {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.newsie-header-clue-button-container {\n  width: 50%;\n}\n\n.newsie-header-clue-button-container.no-clue {\n  display: none;\n}\n\n.newsie-header-clue-button-container.strobe {\n  background-color: rgba(42, 85, 165, 0.137);\n  -webkit-animation: flickerAnimation 2s infinite;\n  -moz-animation: flickerAnimation 2s infinite;\n  -o-animation: flickerAnimation 2s infinite;\n  animation: flickerAnimation 2s infinite;\n  border-radius: 10%;\n}\n\n.newsie-header-clue-button-layout {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.newsie-header-clue-button {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-right: 5%;\n  font-size: 0.75em;\n}\n\n.newsie-header-clue-button-text {\n  font-weight: 900;\n  font-size: xx-small;\n  margin: 3px;\n}\n\n.instructions-question-icon-container {\n  border-style: solid;\n  border-width: 0.5px;\n  border-color: rgba(169, 169, 169, 0.705);\n  padding: 1%;\n  border-radius: 5px;\n  box-shadow: 1px 1px 1px rgba(255, 0, 0, 0.096);\n  min-width: 50px;\n  background-color: rgba(136, 137, 148, 0.055);\n  margin-bottom: 3px;\n}\n\n@keyframes flickerAnimation {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-o-keyframes flickerAnimation {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-moz-keyframes flickerAnimation {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes flickerAnimation {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.client-user-menu-container {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  background-color: rgba(255, 255, 255, 0.938);\n  border: 1px;\n  border-color: rgba(9, 35, 53, 0.411);\n  border-style: solid;\n  border-radius: 3px;\n  padding-right: 8px;\n  padding-left: 8px;\n  justify-content: flex-start;\n}\n\n@media (max-width: 400px) {\n  .client-portal-user-name-text {\n    display: none;\n  }\n  .client-user-menu-container {\n    background-color: transparent;\n    border: none;\n  }\n  .profile-button-icon {\n    padding: 10px;\n    border-radius: 10px;\n    background-color: rgb(143, 168, 188);\n  }\n}\n\n.unauthed-header-title-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: x-large;\n  margin-left: 10px;\n  font-weight: bold;\n}\n\n.header-menu-buttons-container {\n  /* flex: 1; */\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
